import { useActiveBoardContext } from '../../boardv3/stores/ActiveBoardContext';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { EditorView } from '../components/EditorView';

export default function EditorPage() {
  useDocumentTitle('Editor – qtplan');
  const { boardId } = useActiveBoardContext();
  return <EditorView boardId={boardId} />;
}
